import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import './styles/globals.css';
import { createQueryClient } from './lib/query-client';
import { createAppRouter } from './router';
import { AppChrome } from './components/shared/AppChrome';

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);

// Note: Will comment first, in case need this later
// const ReactQueryDevtools = import.meta.env.DEV
//   ? lazy(() =>
//       import('@tanstack/react-query-devtools').then((m) => ({ default: m.ReactQueryDevtools })),
//     )
//   : null;

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <AppChrome />
      {/* {ReactQueryDevtools ? (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
        </Suspense>
      ) : null} */}
    </QueryClientProvider>
  </StrictMode>,
);
